import React, { FC, useContext } from 'react'

import { Card, CardImage, Column, Link, Row, SectionContainer, Text } from '@vividseats/vivid-ui-kit'
import NextLink from 'next/link'

import productionsDetailsContext from '@/context/production-details'
import type { EventLineupPerformer } from '@/context/production-details/types'

import styles from './styles.module.scss'

const EventLineup: FC = () => {
    const {
        selectors: { eventLineup },
    } = useContext(productionsDetailsContext)

    return eventLineup?.performers && eventLineup.performers.length > 0 ? (
        <SectionContainer fluid>
            <Column mb={1.125} mt={0.25}>
                <Text size="lg" weight="bold">
                    {eventLineup.title}
                </Text>
            </Column>

            <Row wrap className={styles.lineupContainer}>
                {eventLineup.performers.map((performer: EventLineupPerformer) => (
                    <div key={performer.id} className={styles.item}>
                        <Link LinkComponent={NextLink} href={performer.url} importance="none">
                            <Card roundedSize="base" className={styles.card}>
                                <CardImage desktopImage={performer.image} mobileImage={performer.image} fade={false} />
                            </Card>
                            <Text size="md" weight="semi-bold" className={styles.title}>
                                {performer.name}
                            </Text>
                        </Link>
                    </div>
                ))}
            </Row>
        </SectionContainer>
    ) : null
}

export default EventLineup
